// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
/**
 * messages for user status
 */
export var UserStatusType;
(function (UserStatusType) {
    UserStatusType["UNKNOWN"] = "UNKNOWN";
    UserStatusType["ACTIVE"] = "ACTIVE";
    UserStatusType["INACTIVE"] = "INACTIVE";
})(UserStatusType || (UserStatusType = {}));
export var UserStatusType_index;
(function (UserStatusType_index) {
    UserStatusType_index[UserStatusType_index["UNKNOWN"] = 0] = "UNKNOWN";
    UserStatusType_index[UserStatusType_index["ACTIVE"] = 1] = "ACTIVE";
    UserStatusType_index[UserStatusType_index["INACTIVE"] = 2] = "INACTIVE";
})(UserStatusType_index || (UserStatusType_index = {}));
export var MigrationMode;
(function (MigrationMode) {
    MigrationMode["VALIDATE"] = "VALIDATE";
    MigrationMode["VALIDATE_UPLOAD"] = "VALIDATE_UPLOAD";
})(MigrationMode || (MigrationMode = {}));
export var MigrationMode_index;
(function (MigrationMode_index) {
    MigrationMode_index[MigrationMode_index["VALIDATE"] = 0] = "VALIDATE";
    MigrationMode_index[MigrationMode_index["VALIDATE_UPLOAD"] = 1] = "VALIDATE_UPLOAD";
})(MigrationMode_index || (MigrationMode_index = {}));
export var UploadMode;
(function (UploadMode) {
    UploadMode["CLI"] = "CLI";
    UploadMode["AMAZON_S3"] = "AMAZON_S3";
})(UploadMode || (UploadMode = {}));
export var UploadMode_index;
(function (UploadMode_index) {
    UploadMode_index[UploadMode_index["CLI"] = 0] = "CLI";
    UploadMode_index[UploadMode_index["AMAZON_S3"] = 1] = "AMAZON_S3";
})(UploadMode_index || (UploadMode_index = {}));
